export default __webpack_public_path__ + "static/media/pic4.09df4a0d.jpg";